import React from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
  HStack,
  Button,
  Box,
  Divider,
  Icon,
} from "@chakra-ui/react";
import { useIntl } from "react-intl";
import { CheckCircleIcon, InfoIcon } from "@chakra-ui/icons";

interface SharingResult {
  alreadySharedCount: number;
  newSharesCount: number;
}

interface SharingToAllResultsModalProps {
  isOpen: boolean;
  onClose: () => void;
  result: SharingResult;
}

const SharingToAllResultsModal: React.FC<SharingToAllResultsModalProps> = ({
  isOpen,
  onClose,
  result,
}) => {
  const intl = useIntl();

  console.log(result);

  const ShareSection: React.FC<{
    title: string;
    description: string;
    count: number;
    icon: any;
    iconColor: string;
  }> = ({ title, description, count, icon, iconColor }) => {
    if (count === 0) return null;

    return (
      <Box mb={6}>
        <HStack mb={3} align="center">
          <Icon as={icon} color={iconColor} boxSize={5} />
          <Text
            fontSize="16px"
            fontWeight="bold"
            color="brand.900"
            fontFamily="Calibri (Body)"
          >
            {title}
          </Text>
        </HStack>
        <Text
          fontSize="14px"
          color="gray.600"
          mb={3}
          fontFamily="Calibri (Body)"
        >
          {description}
        </Text>
      </Box>
    );
  };

  return (
    <Modal isCentered size="md" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      {/* @ts-ignore */}
      <ModalContent
        padding="10px"
        maxWidth="600px"
        width="100%"
        borderRadius="30px"
        maxHeight="80vh"
      >
        <ModalCloseButton />
        <ModalBody overflowY="auto">
          <Text
            color="brand.900"
            fontSize="18px"
            fontWeight="bold"
            fontFamily="Calibri (Body)"
            mb={6}
            textAlign="center"
          >
            {intl.formatMessage({ id: "sharingResults" })}
          </Text>

          <VStack spacing={4} align="stretch">
            {/* Successfully shared emails */}
            <ShareSection
              title={intl.formatMessage({ id: "newlySharedEmails" })}
              description={
                intl.formatMessage({
                  id: "shareToAllSuccessfullCount1",
                }) +
                result.newSharesCount +
                intl.formatMessage({
                  id: "shareToAllSuccessfullCount2",
                })
              }
              count={result.newSharesCount}
              icon={CheckCircleIcon}
              iconColor="green.500"
            />

            {/* Already shared emails */}
            <ShareSection
              title={intl.formatMessage({ id: "alreadySharedEmails" })}
              description={
                intl.formatMessage({
                  id: "shareToAllAlreadyCount1",
                }) +
                result.alreadySharedCount +
                intl.formatMessage({
                  id: "shareToAllAlreadyCount2",
                })
              }
              count={result.alreadySharedCount}
              icon={InfoIcon}
              iconColor="blue.500"
            />
          </VStack>

          <Divider my={6} />

          <HStack justify="center">
            <Button
              variant="outline"
              colorScheme="gray"
              onClick={onClose}
              borderRadius="20px"
              px={8}
            >
              {intl.formatMessage({ id: "close" })}
            </Button>
          </HStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SharingToAllResultsModal;
